function Code({ children, ...props }: React.ComponentPropsWithoutRef<"code">) {
  if (typeof children !== "string") {
    return <code {...props}>{children}</code>;
  }

  return <code {...props} dangerouslySetInnerHTML={{ __html: children }} />;
}

export default Code;
